import { render, staticRenderFns } from "./ActivityEdit.vue?vue&type=template&id=536bf186&"
import script from "./ActivityEdit.vue?vue&type=script&lang=js&"
export * from "./ActivityEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports